<template>
  <div>
    <div v-if="userRole !== 'guest'" class="innerItem">
      <button type="button" class="btn btnFull btnPrimary" disabled>{{locale.save}}</button>
    </div>
    <div v-if="userRole !== 'guest'" class="btnGroup">
      <router-link to="/reservation/item" class="btn btnFull">{{locale.reservation_create}}</router-link>
      <button type="button" class="btn btnFull btnRed" @click="onRemove">{{locale.delete}}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SetReservationList',
  props: [
    'locale',
    'checked',
    'list'
  ],
  computed: {
    userRole () {
      return this.$store.getters['authentication/getAuthInfo'].userRole
    }
  },
  methods: {
    validateOnRemove () {
      if (!this.checked.length) {
        alert(this.locale.validate_reservation_delete_noitem)
        return false
      } else {
        return true
      }
    },
    onRemove () {
      let isPassed = this.validateOnRemove()
      if (isPassed) {
        if (window.confirm(this.locale.confirm_delete_reservation)) {
          this.$emit('delReservation')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btnTemplate {
  display: block;
  margin-right: 0;
  padding: 0.6em 15px;
  border: 1px solid $color-lgrey2;
}
</style>
